module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [(_vm.type === 'mobile') ? _c('div', [(_vm.userType === 'stu' && !_vm.markState) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf',
      "before-upload": _vm.beforeUpload,
      "action": "",
      "http-request": _vm.uploadReport,
      "show-file-list": false,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1) : _vm._e()], 1) : _c('div', [(_vm.userType === 'stu' && !_vm.markState) ? _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": ".doc,.docx,.xls,.xlsx,.pdf",
      "action": "",
      "http-request": _vm.uploadReport,
      "show-file-list": false,
      "file-list": _vm.fileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "555px"
    }
  }, [(_vm.type === 'mobile') ? _c('el-table', {
    ref: "reportListTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.reportListData,
      "height": "250",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "文件名",
      "prop": "fileName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('button', {
          staticStyle: {
            "background-color": "#409eff",
            "border": "none",
            "width": "40px",
            "height": "30px"
          },
          on: {
            "click": function($event) {
              return _vm.fileDownload(scope.row)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#FFFFFF"
          }
        }, [_vm._v("下载")])]), _vm._v(" "), _c('button', {
          staticStyle: {
            "background-color": "#409eff",
            "border": "none",
            "width": "40px",
            "height": "30px"
          },
          on: {
            "click": function($event) {
              return _vm.fileShow(scope.row)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#FFFFFF"
          }
        }, [_vm._v("预览")])]), _vm._v(" "), (_vm.userType === 'stu' && !_vm.markState) ? _c('button', {
          staticStyle: {
            "background-color": "#f56c6c",
            "border": "none",
            "width": "40px",
            "height": "30px"
          },
          on: {
            "click": function($event) {
              return _vm.fileDelete(scope.row)
            }
          }
        }, [_c('span', {
          staticStyle: {
            "font-size": "12px",
            "color": "#FFFFFF"
          }
        }, [_vm._v("删除")])]) : _vm._e()]
      }
    }], null, false, 192371891)
  })], 1) : _c('el-table', {
    ref: "reportListTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.reportListData,
      "height": "250",
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "文件名",
      "prop": "fileName",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "280px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fileDownload(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v(" 下载\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fileShow(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 预览\n                    ")]), _vm._v(" "), (_vm.userType === 'stu' && !_vm.markState) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fileDelete(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete-solid"
        }), _vm._v(" 删除\n                    ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "markForm",
    attrs: {
      "model": _vm.markForm,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [(_vm.userType === 'stu' && _vm.markState) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "点评内容"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "maxlength": "500",
      "show-word-limit": "",
      "readonly": true
    },
    model: {
      value: (_vm.markForm.content),
      callback: function($$v) {
        _vm.$set(_vm.markForm, "content", $$v)
      },
      expression: "markForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点评成绩"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.parseScore(_vm.markForm.score)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.userType === 'tea') ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "点评内容",
      "prop": "content",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": "",
      "readonly": _vm.userType === 'stu'
    },
    model: {
      value: (_vm.markForm.content),
      callback: function($$v) {
        _vm.$set(_vm.markForm, "content", $$v)
      },
      expression: "markForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点评成绩",
      "prop": "score",
      "rules": [{
        required: true,
        message: ' '
      }]
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.markForm.score),
      callback: function($$v) {
        _vm.$set(_vm.markForm, "score", $$v)
      },
      expression: "markForm.score"
    }
  }, _vm._l((_vm.scoreCombo), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin": "10px 0 10px 0"
    }
  }, [(_vm.userType === 'tea') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveScore
    }
  }, [_vm._v("保 存")]) : _vm._e()], 1), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), (_vm.previewerVisible) ? _c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "widthPercent": _vm.previewDialogWidth,
      "heightNum": 650,
      "topNum": 60
    },
    on: {
      "closePreviewer": function($event) {
        _vm.previewerVisible = false;
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04ce218b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/postPracticeManage/report.vue
// module id = 1767
// module chunks = 502